import { render, staticRenderFns } from "./groupRequest.vue?vue&type=template&id=4a6e0aa7&scoped=true"
import script from "./groupRequest.vue?vue&type=script&lang=js"
export * from "./groupRequest.vue?vue&type=script&lang=js"
import style0 from "./groupRequest.vue?vue&type=style&index=0&id=4a6e0aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e0aa7",
  null
  
)

export default component.exports